import {usersService} from 'services'
import {logInUser} from 'utils/user'

const handleRefreshToken = (history, setUser, setLoading) => {
  (async () => {
    const user = JSON.parse(localStorage.getItem('user'))
    setLoading(true)

    if (user && user.email && user.refreshToken) {
      await (usersService.authRefresh({username: user.email, refreshToken: user.refreshToken}).then(r => r.json()
        .then(response => {
          if (response.success) logInUser(response, history, setUser, setLoading)
          else if (history.location?.pathname?.indexOf('/home') !== -1) history.push('/')
        }),
      ))
    } else {
      if (history.location?.pathname?.indexOf('/home') !== -1) history.push('/')
    }
    setLoading(false)
  })()
}

export default handleRefreshToken
